import { layerSource, paintObject, property, layerType } from './Types';

import { Map } from './Map';

import { FeatureLayer } from './FeatureLayer';

import { FilterSpecification } from 'maplibre-gl';

export class PointVectorLayer extends FeatureLayer {
  constructor(
    layerSource: layerSource,
    mapObj: Map,
    sourceLayerId?: string,
    layerId?: string,
    sourceId?: string
  ) {
    super(layerSource, mapObj, sourceLayerId, layerId, sourceId);
  }

  addOutLine = (color: string = 'red', width: number = 1) => {
    // const visibility = this.mapObj.getLayoutProperty(
    //   this.layerId,
    //   'visibility'
    // );

    let parentFilter = this.getFilter();

    if (this.mapObj.getLayer(`${this.layerId}$outline`)) {
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'circle-radius',
        <number>(
          (this.mapObj.getPaintProperty(this.layerId, 'circle-radius') || 5)
        )
      );
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'circle-stroke-color',
        color
      );
      this.mapObj.setPaintProperty(
        `${this.layerId}$outline`,
        'circle-stroke-width',
        width
      );
    } else {
      this.mapObj.addLayer({
        id: `${this.layerId}$outline`,
        type: 'circle',
        source: this.sourceId,
        'source-layer': this.sourceLayer,
        paint: {
          'circle-radius': <number>(
            (this.mapObj.getPaintProperty(this.layerId, 'circle-radius') || 5)
          ),
          'circle-stroke-color': color,
          'circle-stroke-width': width,
        },
      });
    }

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'outline');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'outline');

    this.setSubLayerFilter(<FilterSpecification>parentFilter,'outline');

    // let newOrder = this.mapObj.style._order.indexOf(this.layerId);
    this.mapObj.moveLayerOrder(`${this.layerId}$outline`, this.layerId);
    this.mapObj.moveLayerOrder(this.layerId, `${this.layerId}$outline`);
    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');

    // if (visibility === 'none') {
    //   this.mapObj.setLayoutProperty(
    //     `${this.layerId}$outline`,
    //     'visibility',
    //     'none'
    //   );
    // }
  };

  addHeatmap = (opt: paintObject = <paintObject>{}) => {
    // let visibility;

    // if (this.mapObj.getLayer(`${this.layerId}$heatmap`)) {
    //   visibility = this.mapObj.getLayoutProperty(
    //     `${this.layerId}$heatmap`,
    //     'visibility'
    //   );
    // } else {
    //   visibility = this.mapObj.getLayoutProperty(this.layerId, 'visibility');
    // }

    this.mapObj.setLayoutProperty(this.layerId, 'visibility', 'none');

    if (this.mapObj.getLayer(`${this.layerId}$heatmap`)) {
      if (Object.keys(opt).length > 0) {
        for (const key in opt) {
          this.mapObj.setPaintProperty(
            `${this.layerId}$heatmap`,
            key,
            opt[<'heatmap-radius'| 'heatmap-weight'| 'heatmap-intensity'| 'heatmap-color'| 'heatmap-opacity'>key]
          );
        }
      }
    } else {
      const paint =
        Object.keys(opt).length > 0
          ? opt
          : <paintObject>{
              'heatmap-color': [
                'interpolate',
                ['linear'],
                ['heatmap-density'],
                0,
                'rgba(0,0,255,0)',
                0.15,
                'rgb(0,255,255)',
                0.35,
                'rgb(0,255,0)',
                0.55,
                'rgb(255,255,0)',
                0.75,
                'rgb(255, 145, 0)',
                0.95,
                'rgb(255,0,0)'
              ],
              'heatmap-radius': 10,
            };

            
      this.mapObj.addLayer({
        id: `${this.layerId}$heatmap`,
        type: 'heatmap',
        source: this.sourceId,
        'source-layer': this.sourceLayer,
        paint,
      });
    }

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'heatmap');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'heatmap');

    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
    
    // if (visibility === 'none') {
    //   this.mapObj.setLayoutProperty(
    //     `${this.layerId}$heatmap`,
    //     'visibility',
    //     'none'
    //   );
    // }
  };

  removeHeatmap = () => {
    const visibility = this.mapObj.getLayoutProperty(
      `${this.layerId}$heatmap`,
      'visibility'
    );

    if (this.mapObj.getLayer(`${this.layerId}$heatmap`)) {
      this.mapObj.removeLayer(`${this.layerId}$heatmap`);
    }

    if (visibility !== 'none') {
      this.mapObj.setLayoutProperty(this.layerId, 'visibility', 'visible');
    }
  };

  setHeatmapProperty = (
    type: property,
    value: string | number | Array<string>
  ) => {
    if (!this.mapObj.getLayer(`${this.layerId}$heatmap`)) {
      return;
      // throw new Error("This layer has no heatmap!");
      
    }

    let newvalue: string | number | Array<any>;

    if (type === 'heatmap-color') {
      newvalue = [
        'interpolate',
        ['linear'],
        ['heatmap-density'],
        0,
        (<string[]>value)[0],
        0.15,
        (<string[]>value)[1],
        0.35,
        (<string[]>value)[2],
        0.55,
        (<string[]>value)[3],
        0.75,
        (<string[]>value)[4],
        0.95,
        (<string[]>value)[5],
      ];
    } else {
      newvalue = value;
    }

    this._setLayerProperty(type, newvalue, 'heatmap');

  };

  getHeatmapProperty = (type: property) => {
    if (!this.mapObj.getLayer(`${this.layerId}$heatmap`)) {
      return;
      // throw new Error("This layer has no heatmap!");
      
    }
    const value = <string[]><unknown>this._getLayerProperty(type, 'heatmap');
    return value;

  };

  addCluster = (limit: number = 2000, opt: paintObject = <paintObject>{}) => {

    this.mapObj.setLayoutProperty(this.layerId, 'visibility', 'none');

    if (this.mapObj.getLayer(`${this.layerId}$cluster`)) {
      // if (Object.keys(opt).length > 0){
      //   for (const key in opt) {
      //       this.mapObj.setPaintProperty(
      //         `${this.layerId}$heatmap`,
      //         key,
      //         opt[<'heatmap-radius' | 'heatmap-weight' | 'heatmap-intensity' | 'heatmap-color' | 'heatmap-opacity'>key]
      //       );
      //   }
      // }
    } else {
      try {
        if (this.mapObj.getSource(`client_${this.sourceId}$_cluster`)){
          this.mapObj.removeSource(`client_${this.sourceId}$_cluster`)
        }
        this.mapObj.addSource(`client_${this.sourceId}$_cluster`, {
          type: 'geojson',
          data: `${
            this.source._endpoint
          }features/?f=json&out_srid=4326&limit=${limit}`,
          cluster: true,
          clusterProperties: {
            "cluster_value": ["+", 1]
            // "cluster_value_abbreviated": ["round",["+", 1]],
          }
        });
      } catch (error) {
        throw new Error(String(error));
      }

      try {
        this.mapObj.addLayer({
          id: `${this.layerId}$cluster`,
          type: 'circle',
          source: `client_${this.sourceId}$_cluster`,
          filter: ['has', 'cluster_value'],
          paint: {
            "circle-color": [
              "step",
              ["get", "cluster_value"],
              'rgb(33, 163, 196)',
              20,
              'rgba(116, 234, 22, 1)',
              50,
              'rgb(190, 190, 41)',
              100,
              'rgba(234, 99, 22, 1)',
              750,
              'rgba(255, 0, 0, 1)',
            ],
            "circle-radius": [
              'step',
              ['*',10,['get', 'cluster_value']],
              5,
              20,
              8,
              50,
              10,
              100,
              15,
              750,
              20,
            ]
          }
          // layout: {
          //   'icon-allow-overlap': true,
          //   'icon-size': [
          //     'step',
          //     ['*',10,['get', 'cluster_value']],
          //     5,
          //     20,
          //     8,
          //     50,
          //     10,
          //     100,
          //     15,
          //     750,
          //     20,
          //   ],
          //   'icon-image': this.mapObj.symbolNames.includes('circle-15')
          //     ? 'circle-15'
          //     : this.mapObj.symbolNames[0],
          // },
          // paint: {
          //   'icon-color': [
          //     'step',
          //     ['get', 'cluster_value'],
          //     '#51bbd6',
          //     20,
          //     '#EA6316',
          //     50,
          //     '#74EA16',
          //     100,
          //     '#f1f075',
          //     750,
          //     '#f28cb1',
          //   ],
          // },
        });

        this.mapObj.addLayer({
          id: `${this.layerId}$cluster-count`,
          type: 'symbol',
          source: `client_${this.sourceId}$_cluster`,
          filter: ['has', 'cluster_value'],
          layout: {
            'text-size': 12,
            'text-field': [
              'case',
              ['>=', ['get', 'cluster_value'], 1000000],
              ['concat', ['to-string', ['round', ['/', ['get', 'cluster_value'], 1000000]]], 'M'],
              ['>=', ['get', 'cluster_value'], 1000],
              ['concat', ['to-string', ['round', ['/', ['get', 'cluster_value'], 1000]]], 'k'],
              ['to-string', ['get', 'cluster_value']]
            ],
            'text-allow-overlap': true,
          },
          paint: {
            'text-color': 'rgba(0, 5, 106, 1)',
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 1.5,
          },
        });

        this.mapObj.addLayer({
          id: `${this.layerId}$unclustered`,
          type: 'circle',
          source: `client_${this.sourceId}$_cluster`,
          filter: ['!', ['has', 'cluster_value']],
          paint: {
            "circle-color": "rgb(240, 9, 240)",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff"
          }
          // paint: {
          //   'icon-color': '#11b4da',
          // },
          // layout: {
          //   'icon-size': 4,
          //   'icon-image': this.mapObj.symbolNames.includes('circle-15')
          //     ? 'circle-15'
          //     : this.mapObj.symbolNames[0],
          // },
        });
      } catch (error) {
        throw new Error(String(error));
      }
    }

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'cluster');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'cluster');

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'unclustered');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'unclustered');

    this._setLayerProperty('maxzoom',this.mapObj.getLayer(this.layerId)?.maxzoom ,'cluster-count');
    this._setLayerProperty('minzoom',this.mapObj.getLayer(this.layerId)?.minzoom ,'cluster-count');

    this.mapObj.moveLayerOrder('geobox-gl-splash-circle');
  };

  removeCluster = () => {
    const visibility = this.mapObj.getLayoutProperty(
      `${this.layerId}$cluster`,
      'visibility'
    );
   

    if (this.mapObj.getLayer(`${this.layerId}$cluster`)) {
      try {
        this.mapObj.removeLayer(`${this.layerId}$cluster`);
        this.mapObj.removeLayer(`${this.layerId}$cluster-count`);
        this.mapObj.removeLayer(`${this.layerId}$unclustered`);
        this.mapObj.removeSource(`client_${this.sourceId}$cluster`);
      } catch (error) {}
    }

    if (visibility !== 'none') {
      this.mapObj.setLayoutProperty(this.layerId, 'visibility', 'visible');
    }
  };

  setClusterIconProperty = (type: property, value: string | number| Array<any>, method: string) => {
    if (!this.mapObj.getLayer(`${this.layerId}$cluster`)) {
      return;
      // throw new Error("This layer has no cluster!");
      
    }

    let newValue: string | number | Array<any>;
   
    if (type === 'circle-color') {

      newValue = [
        "step",
        ["get", "cluster_value"],
        (<string[]>value)[4],
        20,
        (<string[]>value)[3],
        50,
        (<string[]>value)[2],
        100,
        (<string[]>value)[1],
        750,
        (<string[]>value)[0],
      ]

    } else {
      newValue = value;
    }

    this._setLayerProperty(type, newValue, 'cluster', method);

    if (type === 'visibility'){
      this._setLayerProperty(type, value, 'unclustered');
      
      this.setClusterLabelProperty(type, value);
    }

  };

  getClusterIconProperty = (type: property) => {
    if (!this.mapObj.getLayer(`${this.layerId}$cluster`)) {
      return;
      // throw new Error("This layer has no cluster!");
      
    }

    if (type === 'weight-field' || type === 'cluster-radius' || type === 'cluster-maxZoom'){
      let style = this.mapObj.getStyle();
      let layerSource = <any> style.sources[`client_${this.sourceId}$_cluster`];

      if (type === 'weight-field'){
        try {
          return layerSource["clusterProperties"]["cluster_value"];
        } catch (error) {
          return undefined;
        }
        
      }else if (type === 'cluster-radius'){
        return layerSource["clusterRadius"];
      }else if (type === 'cluster-maxZoom'){
        return layerSource["clusterMaxZoom"];
      }

    }

    return this._getLayerProperty(type, 'cluster');
  };

  setClusterLabelProperty = (type: property, value: string | number | any[]) => {
    if (!this.mapObj.getLayer(`${this.layerId}$cluster-count`)) {
      return;
      // throw new Error("This layer has no cluster!");
    }

    this._setLayerProperty(type, value, 'cluster-count');
  };

  getClusterLabelProperty = (type: property) => {
    if (!this.mapObj.getLayer(`${this.layerId}$cluster-count`)) {
      return;
      // throw new Error("This layer has no cluster!");
    }

    return this._getLayerProperty(type, 'cluster-count');
    
  };

  setUnClusterIconProperty = (type: property, value: string | number| Array<any>, method: string) => {
    if (!this.mapObj.getLayer(`${this.layerId}$cluster`)) {
      return;
      // throw new Error("This layer has no cluster!");
    }

    this._setLayerProperty(type, value, 'unclustered');

  };

  getUnClusterIconProperty = (type: property) => {
    if (!this.mapObj.getLayer(`${this.layerId}$unclustered`)) {
      return;
      // throw new Error("This layer has no unclustered!");
    }

    return this._getLayerProperty(type, 'unclustered');
  };
}
